module.exports = __webpack_public_path__ + "static/media/toolbar-menu.27c85b64.svg";